import type { StatusEmail } from './interview/config.js';

/**
 * Status emails to candidates when the hiring team decides. A job may override the wording
 * (config.messages); {first_name}, {job_title} and {company} are filled in.
 */
export type StatusEmailKind = 'reject' | 'select';

export const STATUS_EMAIL_DEFAULTS: Record<StatusEmailKind, { subject: string; body: string }> = {
  reject: {
    subject: 'Your application for {job_title} at {company}',
    body: `Hi {first_name},

Thank you for your interest in the {job_title} role at {company}, and for the time you gave to our hiring process.

We have looked at your application carefully and have decided not to move forward with it for this role. This was not an easy decision, and it is not a judgement of your potential.

You are welcome to apply for future openings with us. We wish you every success in your search.

Warm regards,
{company} Hiring Team`,
  },
  select: {
    subject: 'Good news about your application for {job_title} at {company}',
    body: `Hi {first_name},

Congratulations! We are delighted to let you know that you have been selected for the {job_title} role at {company}.

Our team will contact you shortly with the offer details and the next steps. If you have any questions in the meantime, simply reply to this email.

Warm regards,
{company} Hiring Team`,
  },
};

export interface StatusEmailVars {
  firstName: string;
  jobTitle: string;
  company: string;
}

export function fillStatusText(text: string, v: StatusEmailVars): string {
  return text.replace(/\{(first_name|job_title|company)\}/g, (_, k: string) => (k === 'first_name' ? v.firstName : k === 'job_title' ? v.jobTitle : v.company));
}

export function renderStatusEmail(kind: StatusEmailKind, cfg: Pick<StatusEmail, 'subject' | 'body'> | undefined, v: StatusEmailVars): { subject: string; text: string } {
  const d = STATUS_EMAIL_DEFAULTS[kind];
  return { subject: fillStatusText(cfg?.subject || d.subject, v), text: fillStatusText(cfg?.body || d.body, v) };
}
